(() => {
  const modal = document.querySelector('[data-business-calendar-modal]');
  const openButtons = document.querySelectorAll('[data-business-calendar-open]');
  const closeButtons = modal ? modal.querySelectorAll('[data-business-calendar-close]') : [];
  let initialOpened = false;

  const initSidebarCalendarNavigation = () => {
    const sidebarCalendar = document.querySelector('.tajima-sidebar__business-calendar');
    if (!sidebarCalendar) return;

    const prevProxy = sidebarCalendar.querySelector('[data-sidebar-calendar-prev]');
    const nextProxy = sidebarCalendar.querySelector('[data-sidebar-calendar-next]');
    const customNav = sidebarCalendar.querySelector('[data-sidebar-calendar-nav]');
    if (!prevProxy || !nextProxy) return;

    let originalPrev = null;
    let originalNext = null;

    const signatureOf = (element) => {
      const className = typeof element.className === 'string' ? element.className : '';
      return [
        element.getAttribute('aria-label') || '',
        element.getAttribute('title') || '',
        element.getAttribute('data-direction') || '',
        element.getAttribute('data-action') || '',
        className,
        element.textContent || '',
      ].join(' ').toLowerCase();
    };

    const isPrev = (signature) => /(^|[\s_-])(prev|previous|back)([\s_-]|$)|前|戻る|戻|chevron-left|arrow-left/.test(signature);
    const isNext = (signature) => /(^|[\s_-])(next|forward)([\s_-]|$)|次|進む|進|chevron-right|arrow-right/.test(signature);

    const hideOriginalHolidayLegend = () => {
      const candidates = Array.from(sidebarCalendar.querySelectorAll('div, p, span, li')).filter((element) => {
        if (customNav && customNav.contains(element)) return false;
        return (element.textContent || '').replace(/\s+/g, '') === '休業日';
      });

      candidates.forEach((element) => {
        let target = element;
        while (
          target.parentElement &&
          target.parentElement !== sidebarCalendar &&
          (!customNav || !customNav.contains(target.parentElement)) &&
          (target.parentElement.textContent || '').replace(/\s+/g, '') === '休業日'
        ) {
          target = target.parentElement;
        }
        target.classList.add('tajima-calendar-original-holiday-legend');
      });
    };

    const isControlDisabled = (element) => {
      if (!element) return true;
      return (
        element.disabled === true ||
        element.getAttribute('disabled') !== null ||
        element.getAttribute('aria-disabled') === 'true' ||
        element.classList.contains('is-disabled') ||
        element.classList.contains('disabled')
      );
    };

    const syncProxyState = () => {
      prevProxy.disabled = !originalPrev || isControlDisabled(originalPrev);
      nextProxy.disabled = !originalNext || isControlDisabled(originalNext);
    };

    const scan = () => {
      hideOriginalHolidayLegend();
      const candidates = Array.from(sidebarCalendar.querySelectorAll('button, a')).filter((element) => {
        return !customNav || !customNav.contains(element);
      });

      let prev = candidates.find((element) => isPrev(signatureOf(element)));
      let next = candidates.find((element) => isNext(signatureOf(element)));

      if ((!prev || !next) && candidates.length === 2) {
        prev = prev || candidates[0];
        next = next || candidates[1];
      }

      if (originalPrev && originalPrev !== prev) originalPrev.classList.remove('tajima-calendar-original-nav');
      if (originalNext && originalNext !== next) originalNext.classList.remove('tajima-calendar-original-nav');

      originalPrev = prev && prev !== next ? prev : null;
      originalNext = next && prev !== next ? next : null;

      if (originalPrev) originalPrev.classList.add('tajima-calendar-original-nav');
      if (originalNext) originalNext.classList.add('tajima-calendar-original-nav');
      syncProxyState();
    };

    prevProxy.addEventListener('click', () => {
      if (!originalPrev || prevProxy.disabled) return;
      originalPrev.click();
      window.setTimeout(scan, 0);
      window.setTimeout(scan, 150);
    });

    nextProxy.addEventListener('click', () => {
      if (!originalNext || nextProxy.disabled) return;
      originalNext.click();
      window.setTimeout(scan, 0);
      window.setTimeout(scan, 150);
    });

    const observer = new MutationObserver(scan);
    observer.observe(sidebarCalendar, { childList: true, subtree: true });
    scan();
    window.setTimeout(scan, 250);
    window.setTimeout(scan, 1000);
  };

  const openModal = () => {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tajima-business-calendar-open');
  };

  const closeModal = () => {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tajima-business-calendar-open');
  };

  openButtons.forEach((button) => button.addEventListener('click', openModal));
  closeButtons.forEach((button) => button.addEventListener('click', closeModal));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
  });

  const openInitial = () => {
    if (initialOpened) return;
    initialOpened = true;
    window.setTimeout(openModal, 120);
  };

  const waitForHomeLoader = () => {
    const loader = document.getElementById('tajima-home-loader');
    if (!loader) {
      openInitial();
      return;
    }

    const observer = new MutationObserver(() => {
      if (!document.getElementById('tajima-home-loader')) {
        observer.disconnect();
        openInitial();
      }
    });
    observer.observe(document.body, { childList: true });

    window.setTimeout(() => {
      observer.disconnect();
      openInitial();
    }, 6000);
  };

  const init = () => {
    initSidebarCalendarNavigation();

    if (document.body.classList.contains('template-index')) {
      window.addEventListener('load', waitForHomeLoader, { once: true });
      if (document.readyState === 'complete') waitForHomeLoader();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
